// extracted by mini-css-extract-plugin
module.exports = {"App":"app_App__V3s5Z","App-logo":"app_App-logo__1iSPb","App-logo-spin":"app_App-logo-spin__3zaJ0","App-header":"app_App-header__2T7Ob","App-link":"app_App-link__da9Nn"};